import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ClockIcon, MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';
import { contactDetails } from '../data/house';
export function Contact() {
  return <>
      <PageHeader eyebrow="Contact" title="We’re here to help" intro="Questions about a stay, a shoot or a special request? Reach out. For dates and pricing, the booking page is the fastest route." data-id="element-515" data-mp="1lr1jxtj8u78m" />

      <section className="bg-ivory-100" data-id="element-516" data-mp="17qigkzpq3pcs">
        <div className="mx-auto max-w-[1240px] px-5 py-20 sm:px-8 lg:px-12 lg:py-28" data-id="element-517" data-mp="17racycr59r44">
          <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-518" data-mp="12zin64ftbpf1">
            <Reveal data-id="element-519" data-mp="f9xx71l8rrw9">
              <ul className="space-y-8" data-id="element-520" data-mp="f963xxf4a695">
                <ContactRow icon={<PhoneIcon size={18} data-id="element-522" data-mp="ab4m1ftfgcz9" />} label="Phone" data-id="element-521" data-mp="f83bhl25bvr4">
                  <a href={contactDetails.phoneHref} className="font-display text-xl text-forest-700 transition-colors duration-150 ease-premium hover:text-gold-600" data-id="element-523" data-mp="aalemt1el6zh">
                    {contactDetails.phone}
                  </a>
                </ContactRow>
                <ContactRow icon={<MessageCircleIcon size={18} data-id="element-525" data-mp="1e8s4pkquqf3a" />} label="WhatsApp" data-id="element-524" data-mp="1e78ofu57441i">
                  <a href={contactDetails.whatsappHref} target="_blank" rel="noreferrer" className="font-display text-xl text-forest-700 transition-colors duration-150 ease-premium hover:text-gold-600" data-id="element-526" data-mp="1j6tvysyflkpu">
                    {contactDetails.whatsapp}
                  </a>
                </ContactRow>
                <ContactRow icon={<MailIcon size={18} data-id="element-528" data-mp="10gvifxbv6zet" />} label="Email" data-id="element-527" data-mp="10gc6cx8wb58p">
                  <a href={contactDetails.emailHref} className="break-all font-display text-xl text-forest-700 transition-colors duration-150 ease-premium hover:text-gold-600" data-id="element-529" data-mp="10e985pxla5sw">
                    {contactDetails.email}
                  </a>
                </ContactRow>
                <ContactRow icon={<MapPinIcon size={18} data-id="element-531" data-mp="1m5iqdyfhhlba" />} label="Address" data-id="element-530" data-mp="1m6275btee3nq">
                  <p className="text-[15px] leading-relaxed text-ink" data-id="element-532" data-mp="1h922n5c758yq">{contactDetails.address}</p>
                </ContactRow>
                <ContactRow icon={<ClockIcon size={18} data-id="element-534" data-mp="1w4rpf5p7hq4i" />} label="Hours" data-id="element-533" data-mp="1w517m740eszn">
                  <p className="text-[15px] leading-relaxed text-ink" data-id="element-535" data-mp="1r66rxe1c9kjr">{contactDetails.hours} · Check-in 2 PM · Checkout 12 noon</p>
                </ContactRow>
              </ul>

              <Link to="/booking" className="group mt-12 inline-flex items-center gap-2 rounded-full bg-forest-700 px-6 py-3 text-sm text-ivory-100 transition-colors duration-150 ease-premium hover:bg-forest-600" data-id="element-536" data-mp="yi16sq6dhtje">
                Book a stay
                <ArrowRightIcon size={15} className="transition-transform duration-200 ease-premium group-hover:translate-x-1" aria-hidden="true" data-id="element-537" data-mp="kqe7sil1q6wx" />
              </Link>
            </Reveal>

            <Reveal delay={0.06} data-id="element-538" data-mp="fpgpm601dcvf">
              <div className="overflow-hidden rounded-sm shadow-soft" data-id="element-539" data-mp="2red5y7l4vhj3">
                <iframe title="Map showing Bel Air Luxury Apartment in GRA, Benin City" src="https://www.openstreetmap.org/export/embed.html?bbox=5.60%2C6.31%2C5.65%2C6.35&layer=mapnik" className="h-[420px] w-full border-0 grayscale-[0.35]" loading="lazy" data-id="element-540" data-mp="2w5d41g5zo5n6" />
              </div>
              <p className="mt-4 text-[13px] leading-relaxed text-muted" data-id="element-541" data-mp="3a5xm2a42xxfm">
                Located off Ihama Road, GRA, Benin City. Exact directions are shared once your booking is confirmed.
              </p>
            </Reveal>
          </div>
        </div>
      </section>
    </>;
}
function ContactRow({
  icon,
  label,
  children
}: {
  icon: React.ReactNode;
  label: string;
  children: React.ReactNode;
}) {
  return <li className="border-b border-forest-700/10 pb-7 last:border-0" data-id="element-542" data-mp="1prdto8vlvsck">
      <p className="flex items-center gap-2.5 text-[11px] uppercase tracking-overline text-gold-700" data-id="element-543" data-mp="1tro0tov4wot0">
        <span className="text-gold-500" aria-hidden="true" data-id="element-544" data-mp="29zlrbycmh0ol">
          {icon}
        </span>
        {label}
      </p>
      <div className="mt-2.5" data-id="element-545" data-mp="2557qvhj3s3d2">{children}</div>
    </li>;
}